// @Version: 1.0.4
import { Component, forwardRef, EventEmitter, Output, Input, OnInit, AfterContentInit, OnDestroy, SimpleChanges, OnChanges } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormBuilder, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from "@angular/forms";
import { UntilDestroy } from '@ngneat/until-destroy';
import { IFieldItem } from '../field-item.model';
import { TransformItemService } from './transform-item.service';
import { ILinkButtonMetaData } from './link-button.model';
import { TRANSLATE_PATH } from 'src/app/shared/shared.model';
import { ErrorMessagesService } from 'src/app/shared/services/errorMessages/error-messages.service';
import { Subscription } from 'rxjs';

@UntilDestroy()
@Component({
   selector: 'app-field-item-link-button',
   templateUrl: './link-button.component.html',
   providers: [
      {
         provide: NG_VALUE_ACCESSOR,
         useExisting: forwardRef(() => FieldItemLinkButtonComponent),
         multi: true
      },
      {
         provide: NG_VALIDATORS,
         useExisting: forwardRef(() => FieldItemLinkButtonComponent),
         multi: true
      },
      ErrorMessagesService
   ],
   standalone: false
})

export class FieldItemLinkButtonComponent implements OnChanges, AfterContentInit, ControlValueAccessor, Validator, OnDestroy {

   public TRANSLATE_PATH = TRANSLATE_PATH; 

   public fcLinkButton: FormControl = this.fb.control("");
   private sub_?: Subscription;

   public metaData: ILinkButtonMetaData = {} as ILinkButtonMetaData; 

   private fieldItem_: IFieldItem = {} as IFieldItem;
   private colors_: string[] = [];
   private icons_: string[]= [];

   @Input()
   set fieldItem (value: IFieldItem) {
      this.fieldItem_ = value;

   }
   get fieldItem (): IFieldItem {
      return this.fieldItem_;
   }

   @Output() isRequiredMarker: EventEmitter<boolean> = new EventEmitter<boolean>();

   get colorSuccess (): string {
      return this.colors_[1];
   }

   get colorDefault (): string {
      return this.colors_[0];
   }

   get iconSuccess (): string {
      return this.icons_[1];
   }

   get iconDefault (): string {
      return this.icons_[0];
   }

   constructor (private sTransform: TransformItemService, private fb: FormBuilder) {}
 
   ngOnChanges (changes: SimpleChanges): void {
       if (changes && changes.fieldItem &&  (JSON.stringify(changes.fieldItem.currentValue) != JSON.stringify(changes.fieldItem.previousValue))) {
         this.colors_ = this.sTransform.transform(changes.fieldItem.currentValue.attribute_1);
         this.icons_ = this.sTransform.transform(changes.fieldItem.currentValue.attribute_3);
         if (this.sub_) {
            this.sub_.unsubscribe();
            this.sub_ = undefined;
         }
         this.fcLinkButton.setValue(this.formatContent(changes.fieldItem.currentValue.content));
         this.sub_ = this.fcLinkButton.valueChanges.subscribe(() => { 
               if (!this.value && this.fcLinkButton.pristine) return;
               this.onChange(this.value);
               this.onTouched();
            });  
            this.isRequiredMarker.emit(changes.fieldItem.currentValue.required);
            
            this.onValidationChange();
         }
   }

   ngOnDestroy (): void {
      this.fcLinkButton = this.fb.control("");
      this.metaData = {} as ILinkButtonMetaData; 
      this.fieldItem_ = {} as IFieldItem;
      this.colors_ = [];
      this.icons_= [];
   }

   onValidationChange: any = () => {}; 

   ngAfterContentInit (): void {
      this.onChange(this.value);
      this.onTouched();
   }

   validate (control: AbstractControl): ValidationErrors | null {
      this.fcLinkButton.updateValueAndValidity({emitEvent: false, onlySelf: true});
      return !this.fcLinkButton.dirty && this.fieldItem.required ? {noLink: true} : null; 
   }
   
   registerOnValidatorChange? (fn: () => void): void {
      this.onValidationChange = fn;
   }

   get value (): boolean {
      return this.fcLinkButton.dirty ? true : false;
   }

   writeValue (input: boolean | string | undefined | null): void {
      const value = this.formatContent(input);
      this.fcLinkButton.setValue(value ? value : undefined);
      if (value) this.setDirtyTouched();
      this.onValidationChange();
   }

   private setDirtyTouched (): void {
      this.fcLinkButton.markAsDirty(); 
      this.fcLinkButton.markAsTouched();
   }

   private formatContent (input: boolean | string | undefined | null): boolean {
      return typeof input == "string" && input == "true" ? true : typeof input == 'boolean' ? input : false;
   }

   private onTouched () {}

   private onChange (_: boolean) {}

   registerOnChange (fn: any): void {     
     this.onChange = fn
   }

   registerOnTouched (fn: any): void { 
      this.onTouched = fn; 
   }

   public onKeyboardEnter () {
      this.fcLinkButton.markAsDirty();
      this.fcLinkButton.markAsTouched();
      this.onChange(this.value)
   }
}